module.exports = "/_next/static/chromiums/og-1200x630-index-27e0e6d307abc8aaedaf58f18f72d300.jpg";